import React from 'react';
import { styled } from 'styled-components';
import { ShowResultTitle } from './ShowResultTitle';
import { ShowSearchResultList } from './ShowSearchResultList';
import { Colors } from '../../../../../play-core/styles/Colors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowResults = ({
  searchTerm,
  shows
}) => /*#__PURE__*/_jsxs(Container, {
  children: [/*#__PURE__*/_jsx(ShowResultTitle, {
    searchTerm: searchTerm
  }), /*#__PURE__*/_jsx(ShowSearchResultList, {
    shows: shows,
    searchTerm: searchTerm
  })]
});
const Container = styled.section.withConfig({
  displayName: "ShowResults__Container",
  componentId: "sc-1g01mhn-0"
})(["background-color:", ";"], Colors.BLACK);